export type FontAwesomeFontSet =
  | 'fab'
  | 'fa-brands'
  | 'fad'
  | 'fa-duotone'
  | 'fal'
  | 'fa-light'
  | 'fa'
  | 'far'
  | 'fa-regular'
  | 'fasds'
  | 'fa-sharp-duotone-solid'
  | 'fasl'
  | 'fa-sharp-light'
  | 'fasr'
  | 'fa-sharp-regular'
  | 'fass'
  | 'fa-sharp-solid'
  | 'fast'
  | 'fa-sharp-thin'
  | 'fas'
  | 'fa-solid'
  | 'fat'
  | 'fa-thin';

export function fontAwesomeSvgUrl(fontSet: FontAwesomeFontSet, fontIcon: string) {
  //todo fed: make config and copy assets to fed boundary
  return `https://assets.fusus.com/font-awesome/SVG/${_fontSetToAssetFolder(
    fontSet,
  )}/${fontIcon?.toLowerCase()}.svg`;
}

function _fontSetToAssetFolder(fontSet: FontAwesomeFontSet): string {
  switch (fontSet) {
    case 'fab':
    case 'fa-brands':
      return 'brands';
    case 'fad':
    case 'fa-duotone':
      return 'duotone';
    case 'fal':
    case 'fa-light':
      return 'light';
    case 'fasds':
    case 'fa-sharp-duotone-solid':
      return 'sharp-duotone-solid';
    case 'fasl':
    case 'fa-sharp-light':
      return 'sharp-light';
    case 'fasr':
    case 'fa-sharp-regular':
      return 'sharp-regular';
    case 'fass':
    case 'fa-sharp-solid':
      return 'sharp-solid';
    case 'fast':
    case 'fa-sharp-thin':
      return 'sharp-thin';
    case 'fas':
    case 'fa-solid':
      return 'solid';
    case 'fat':
    case 'fa-thin':
      return 'thin';
    case 'fa':
    case 'far':
    case 'fa-regular':
    default:
      return 'regular';
  }
}
